import React, {Fragment} from 'react';
import { useAuth } from '../../Context/Context';
import { WavyLink } from "react-wavy-transitions";

import img1 from "../../Images/Servicios/Animacion/1.png"
import img2 from "../../Images/Servicios/Animacion/2.png"


import Portafolio from '../../Components/Portafolio';
import Efectos from '../../Components/Efectos';
import Contacto from '../../Components/Contacto';


const Animacion = () => {
    const { direction, cambio } = useAuth();

    return(
        <Fragment>
            <div>
                <div className='fondo_servicio_5'>
                    <div className=''>
                        <p className='sub_titulo_nv_4' style={{color:"#ffffff"}}>
                            <span className='titulo_nv_2' style={{color:"#ED3E75"}}>
                                Animaciones <br/>
                            </span>
                            Todo es mejor con movimiento
                        </p>
                        <div>
                            <p>
                                ¿Actualización de logo? <br/>
                                ¿Nuevas promociones? <br/>
                                ¿Instrucciones de algún producto?
                            </p>
                            <p className='cont_7'>
                                Mejor dilo con un vídeo de animación digital
                            </p>
                        </div>
                    </div>
                    <div>
                        {window.screen.width <= 550 ? (
                            <Efectos activado={true}>
                                <img class="scroll-element js-scroll fade-in-bottom" src={img2} alt="" style={{width:"100%"}}/>
                            </Efectos>
                        ) : (
                            <Efectos activado={true}>
                                <img class="scroll-element js-scroll fade-in-bottom" src={img1} alt="" style={{width:"100%", maxWidth:"1485px"}}/>
                            </Efectos>
                        )}
                    </div>
                </div>
                

                <div className='row cont_12' style={{marginBottom:"40px"}}>
                    <div className='col s12 m6'>
                        <div class="contenedor_video" style={{marginTop:"20px"}}>
                            <iframe
                                title="¡Nueva página del CAAV!"
                                className='video'
                                src="https://www.youtube.com/embed/7z5v0wdSdAQ?modestbranding=1&rel=0&fs=0"
                            ></iframe>
                        </div>
                    </div>
                    <div className='col s12 m6' style={{marginTop:"20px"}}>
                        <div class="contenedor_video">
                            <iframe
                                title="Latino Vegas"
                                className='video'
                                src="https://www.youtube.com/embed/DiP0sSdMVQc?modestbranding=1&rel=0&fs=0"
                            ></iframe>
                        </div>
                    </div>
                    <div className='col s12 m6' style={{marginTop:"20px"}}>
                        <div class="contenedor_video">
                            <iframe
                                title="Beca CAAV 2022"
                                className='video'
                                src="https://www.youtube.com/embed/LGg3dW1j_DI?modestbranding=1&rel=0&fs=0"
                            ></iframe>
                        </div>
                    </div>
                    <div className='col s12 m6' style={{marginTop:"20px"}}>
                        <div class="contenedor_video">
                            <iframe
                                title="MECI"
                                className='video'
                                src="https://www.youtube.com/embed/UKdt56gbgjQ?modestbranding=1&rel=0&fs=0"
                            ></iframe>
                        </div>
                    </div>
                </div>

                <div style={{display:"flex", justifyContent:"center", marginBottom:"50px"}}>
                    <WavyLink direction={direction ? "up" : "down"} to="/contacto" color={direction ? "#BF1F60" : "#2A79B0"}>
                        <p class="btn_1" onClick={cambio} style={{margin:"0px", color:"#fff"}}>
                            Cotiza tu proyecto
                        </p>
                    </WavyLink>
                    {/* <div className='btn_1'>
                        <a href="/contacto" style={{color:"#fff"}}>
                            <p>
                                Cotiza tu proyecto
                            </p>
                        </a>
                    </div> */}
                </div>

                <Portafolio />
                <Contacto />

                
            </div>
        </Fragment>
    )
}

export default Animacion;